export default function StepLabel(theme) {
  return {
    MuiStepLabel: {
      styleOverrides: {
        label: {
          textAlign: 'left !important',
          marginTop: '10px !important',
          lineHeight: 0.2
        },
        labelContainer: {
          lineHeight: 1,
          textAlign: 'left !important',
          color: theme.palette.text.disabled
        }
     },
    },
  };
}
